module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    attrs: {
      "id": "cliente-section"
    }
  }, [_c('div', {
    attrs: {
      "id": "sessao_dados_do_cliente"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "Empresa"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "male"
    }
  }), _vm._v(" Dados da empresa")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.customer.document')
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['XX.XXX.XXX/XXXX-##']),
      expression: "['XX.XXX.XXX/XXXX-##']"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^([A-Za-z0-9]{2}.[A-Za-z0-9]{3}.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2})$/
        }
      }),
      expression: "{ rules: { required: true, regex: /^([A-Za-z0-9]{2}.[A-Za-z0-9]{3}.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-\\d{2})$/ } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.document),
      expression: "customer.document"
    }],
    staticClass: "form-control update-driver",
    attrs: {
      "type": "text",
      "id": "data.customer.document",
      "name": "data.customer.document",
      "data-vv-as": "CNPJ"
    },
    domProps: {
      "value": (_vm.customer.document)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "document", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.customer.document')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.customer.document')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.customer.name')
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "form-control update-driver",
    attrs: {
      "type": "text",
      "id": "data.customer.name",
      "name": "data.customer.name",
      "data-vv-as": "Razão Social"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value)
      }, function($event) {
        _vm.$emit('update:modelValue', $event.target.value)
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('data.customer.name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.customer.name')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.customer.email')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.customer.email"
    }
  }, [_vm._v("E-mail "), (_vm.contactValidate) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.contactValidate,
          email: true
        }
      }),
      expression: "{ rules: { required: contactValidate, email: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "data.customer.email",
      "name": "data.customer.email",
      "data-vv-as": "E-mail"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.customer.email')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.customer.email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.customer.phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "ata[customer][phone]"
    }
  }, [_vm._v("Telefone "), (_vm.contactValidate) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.contactValidate,
          regex: /^(\(\d{2}\) \d{4}-\d{4}|\(\d{2}\) \d{5}-\d{4})$/
        }
      }),
      expression: "{ rules: { required: contactValidate, regex: /^(\\(\\d{2}\\) \\d{4}-\\d{4}|\\(\\d{2}\\) \\d{5}-\\d{4})$/ } }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.phone),
      expression: "customer.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ata[customer][phone]",
      "name": "data.customer.phone",
      "data-vv-as": "Telefone"
    },
    domProps: {
      "value": (_vm.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.customer.phone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.customer.phone')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.customer.celphone')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.customer.celphone"
    }
  }, [_vm._v("Celular para contato ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.celphone),
      expression: "customer.celphone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "data.customer.celphone",
      "name": "data.customer.celphone",
      "data-vv-as": "Celular para contato"
    },
    domProps: {
      "value": (_vm.customer.celphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "celphone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.customer.celphone')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.customer.celphone')))]) : _vm._e()])])]), _vm._v(" "), (!_vm.showFormCustomer) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('chkConsentimento')
    }
  }, [_c('label', {
    attrs: {
      "for": "chkConsentimento"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkConsentimento",
      "name": "chkConsentimento",
      "data-vv-as": "check de consentimento"
    }
  }), _vm._v(" \n                                Declaro que solicitei a prévia autorização para utilização dos dados do titular conforme a base legal prevista no artigo 7°, inciso V, da LGPD. "), _c('a', {
    attrs: {
      "href": "https://www.segfy.com/termos-de-uso/",
      "target": "_blank"
    }
  }, [_vm._v("Ler Política de Privacidade")])]), _vm._v(" "), (_vm.errors.has('chkConsentimento')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('chkConsentimento')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showFormCustomer) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('chkConsentimento2')
    }
  }, [_c('label', {
    attrs: {
      "for": "chkConsentimento2"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chkConsentimento2",
      "name": "chkConsentimento2",
      "data-vv-as": "check de consentimento"
    }
  }), _vm._v(" Eu autorizo que sejam tomadas decisões referentes ao tratamento de meus dados pessoais, bem como seja realizado o devido tratamento envolvendo\n                                operações como as que se referem a coleta, a utilização, o processamento, e o controle da informação para a cotação de meu seguro. A autorização irá expirar em 90 dias, \n                                caso sejam realizadas consultas após esse período, então será necessário realizar o aceite novamente. "), _c('a', {
    attrs: {
      "href": "https://www.segfy.com/termos-de-uso/",
      "target": "_blank"
    }
  }, [_vm._v("Ler Política de Privacidade")])]), _vm._v(" "), (_vm.errors.has('chkConsentimento2')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('chkConsentimento2')))]) : _vm._e()])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data.customer.document"
    }
  }, [_vm._v("CNPJ "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data.customer.name"
    }
  }, [_vm._v("Razão Social "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99e595c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/modules/CustomerNew/FormPartialCustomer.vue
// module id = 348
// module chunks = 0